/**
 * The colour a territory falls back to when it has none of its own.
 *
 * One definition, because seven places had their own copy of this hex under three different names
 * and a brand change would have had to find all of them. ColorHex is nullable on the server --
 * null means "let the client pick" -- so every surface that paints a territory needs this answer,
 * and they all have to give the same one or the map, the manage panel and the report disagree
 * about what colour a territory is.
 */
export const DEFAULT_TERRITORY_COLOR = '#1F7A3F'
